module.exports = __webpack_public_path__ + "static/graph-year-1_fr-f47ced6c4dc172b4ce462371fe0a7a3c.svg";